import styles from './CollapsibleCard.module.css';
import React from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

export const CollapsibleCard = ({
    title,
    children,
    headerIcon,
    headerColor = 'default',
    initiallyExpanded = false,
    showChevron = true,
    onToggle,
    className = ''
}) => {
    const [ isExpanded, setIsExpanded ] = React.useState(initiallyExpanded);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);

        onToggle && onToggle(!isExpanded);
    };

    const headerColorClass = styles[ `header-${ headerColor }` ] || styles.headerDefault;

    return (
        <div className={ `${ styles.cardContainer } ${ className }` }>
            <div
                className={ `${ styles.header } ${ headerColorClass }` }
                onClick={ toggleExpanded }
            >
                <span className={ styles.headerContent }>
                    { headerIcon && <span className={ styles.headerIcon }>{ headerIcon }</span> }
                    
                    <span>{ title }</span>
                </span>
                { showChevron && (
                    <span>
                        {isExpanded ? <ExpandLess /> : <ExpandMore />}
                    </span>
                ) }
            </div>

            <div className={ `${ styles.content } ${ isExpanded ? styles.expanded : styles.collapsed }` }>
                { children }
            </div>
        </div>
    );
};